import { ColumnAlign } from "./types";

/** Maps a column alignment to the flex `justify-*` class for its header/cell content. */
export const alignToJustify = (align?: ColumnAlign): string => {
  switch (align) {
    case "center":
      return "justify-center";
    case "right":
      return "justify-end";
    default:
      return "justify-start";
  }
};

/**
 * Maps a column alignment to the `text-*` class for its header label.
 *
 * The header label is a `flex-1` `Text`, so it fills the cell and the
 * container's `justify-*` has nothing left to push around — without this the
 * label stayed left-aligned while the right-aligned numeric cells below it
 * did not line up with it.
 */
export const alignToTextAlign = (align?: ColumnAlign): string => {
  switch (align) {
    case "center":
      return "text-center";
    case "right":
      return "text-right";
    default:
      return "text-left";
  }
};
